import React, { Component } from 'react';

import EditLevel from './EditLevel.js';

class EditLevelContainer extends Component {
    constructor(props) {
        super(props);
    }

    getLevels() {
        var levels = [];
        for(var i = 0; i < this.props.numLevels; i++) {
            var level = i+1;
            levels.push({key:i, value:level, locked:level>this.props.maxLevel, active:(level==this.props.level)});
        }
        return levels;
    }


    render() {
        return <EditLevel {...this.props} levels={this.getLevels()} />;
    }
}

export default EditLevelContainer;



// WEBPACK FOOTER //
// ./src/modules/categories/EditLevelContainer.js